export default __webpack_public_path__ + "static/media/template5.ecf18788.svg";